import type { ConnectionAccessFilter } from "../ConnectionAccessSettings";

export type ConnectionScopeCounts = Record<ConnectionAccessFilter, number>;

export const getConnectionScopeCounts = <TRow extends { isConnectionOwnedByCurrentUser: boolean }>(
    activeRows: TRow[],
): ConnectionScopeCounts => ({
    all: activeRows.length,
    owned_by_me: activeRows.filter((row) => row.isConnectionOwnedByCurrentUser).length,
});

/**
 * The "Connected by me" scope is only meaningful after we know it has rows.
 * Treat an unresolved result as hidden to avoid exposing a filter that will
 * immediately disappear once connection data finishes loading.
 */
export const shouldShowOwnedConnectionScope = (
    hasOwnedWorkspaceConnections: boolean | null,
) => hasOwnedWorkspaceConnections === true;

export const resolveConnectionScopeAfterAvailability = (
    currentScope: ConnectionAccessFilter,
    hasOwnedWorkspaceConnections: boolean | null,
): ConnectionAccessFilter =>
    !shouldShowOwnedConnectionScope(hasOwnedWorkspaceConnections)
    && currentScope === "owned_by_me"
        ? "all"
        : currentScope;
